import Vuex from "vuex";
import Vue from "vue";
import { graphqlClient } from "../utils/graphql";
import gql from "graphql-tag";
import { MUTATION_LOGIN } from "@/models/mutations/LoginMutation";
import { Role } from "@/models/graphql-global-types";

Vue.use(Vuex);

const userStore = {
  namespaced: true,
  state: {
    isUserTester: false
  },
  mutations: {},
  actions: {
    async login({}, data) {
      try {
        const result = await graphqlClient.mutate({
          mutation: gql`
            ${MUTATION_LOGIN}
          `,
          variables: data
        });

        const token = result.data.login.token;
        const user = result.data.login.user;
        sessionStorage.setItem("cedoon_token", token);
        sessionStorage.setItem("cedoon_user", JSON.stringify(user));

        return true;
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  }
};

export default userStore;
